import * as React from 'react';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import { TopBar } from '.';
import { Categories } from './PortalSearchBar';
import { IAppOnlyStore } from './../../stores/AllStores';
import { UserDropdown } from './UserDropdown';
import { WarehousesLocations } from './WarehousesLocations';
import { ChangePasswordModal } from './ChangePasswordModal';
import { OrdersHistory } from './OrdersHistory';
import { EUserTypeName } from '../../../../common/interfaces/user';
import { InsuranceJobsList } from './InsuranceJobsList';
import { IInsurance } from '../../../../common/interfaces/insurance';

// Styles
const s = require('./Layout.css');

// Component
@inject('store')
@observer
export class Layout extends React.Component<IAppOnlyStore, {}> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        const { user, warehouse, orders, cart, insurance } = this.props.store;

        return (
            <div onClick={this.handleLayoutContainerClick} className={s.layout}>
                {user.isLoggedIn && <UserDropdown />}

                <TopBar
                    onUserDropdownButtonClick={this.handleUserDropdownClick}
                    userDropdownIsOpen={user.showUserDropdown}
                    userType={user.userType}
                    userEmail={user.email}
                    customerIsPAC={user.customerIsPAC}
                    customerIsPBI={user.customerIsPBI}
                />

                <div onClick={this.handleContentClick} className={s.content}>
                    {this.props.children}
                </div>

                {user.isLoggedIn && user.userType === EUserTypeName.Portal && <Categories />}

                {user.isLoggedIn && user.userType === EUserTypeName.Portal && <OrdersHistory />}

                {user.isLoggedIn &&
                    user.userType === EUserTypeName.Portal && (
                        <WarehousesLocations
                            customerType={user.customerType}
                            showWarehouses={warehouse.showWarehousesLocations}
                            warehouses={warehouse.warehousesLocationsOfUserList}
                            onModalClose={this.handleWarehousesLocationsModalClose}
                        />
                    )}

                {user.isLoggedIn &&
                    user.userType === EUserTypeName.Portal && (
                        <InsuranceJobsList
                            showInsuranceJobsModal={insurance.showInsuranceJobsList}
                            selectedInsurer={cart.selectedInsuranceJob}
                            insuranceJobs={insurance.searchedInsuranceJobs}
                            searchQuery={insurance.search}
                            onModalClose={this.handleInsuranceJobsListModalClose}
                            onSearch={this.handleInsuranceJobsListSearch}
                            onInsurerClick={this.handleInsurerClick}
                        />
                    )}

                {user.isLoggedIn && <ChangePasswordModal />}
            </div>
        );
    }

    @action
    private handleLayoutContainerClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (this.props.store.user.showUserDropdown) {
            this.props.store.user.showUserDropdown = false;
        }
    };

    private handleContentClick = (e: React.MouseEvent<HTMLDivElement>) => {
        this.props.store.autocomplete.clearSuggestions();
    };

    @action
    private handleWarehousesLocationsModalClose = () => {
        this.props.store.warehouse.showWarehousesLocations = false;
    };

    @action
    private handleInsuranceJobsListModalClose = () => {
        if (this.props.store.cart.selectedInsuranceJob === null || this.props.store.cart.isInsuranceJob === false) {
            this.props.store.cart.selectedInsuranceJob = null;
            this.props.store.cart.isInsuranceJob = false;
        }

        this.props.store.insurance.showInsuranceJobsList = false;
    };

    @action
    private handleInsuranceJobsListSearch = (field: string, value: string, e: React.ChangeEvent<HTMLInputElement>) => {
        this.props.store.insurance.search = value;
    };

    @action
    private handleInsurerClick = (insurer: IInsurance) => (e: React.MouseEvent<HTMLButtonElement>) => {
        this.props.store.cart.selectedInsuranceJob = insurer;
        this.props.store.insurance.showInsuranceJobsList = false;
    };

    @action
    private handleUserDropdownClick = () => {
        const { user } = this.props.store;
        user.showUserDropdown = !user.showUserDropdown;
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/layout/Layout.tsx